export const scheduleOREMeetingTypesEnum = {
  Escuela: 1,
  COMPU: 2,
};
